/**
 * FloatingToolbarRight - Right floating toolbar
 * Contains: Current credits display with hover history + profile icon/menu
 */

import UserMenu from '../UserMenu';
import './FloatingToolbarRight.css';

interface FloatingToolbarRightProps {
  onSaveAsTemplate: () => void;
  onUpdateTemplate: () => void;
  hasLoadedTemplate: boolean;
}

export function FloatingToolbarRight({
  onSaveAsTemplate,
  onUpdateTemplate,
  hasLoadedTemplate
}: FloatingToolbarRightProps) {
  return (
    <div className="floating-toolbar-right">
      {/* User Menu */}
      <UserMenu 
        onSaveAsTemplate={onSaveAsTemplate}
        onUpdateTemplate={onUpdateTemplate}
        hasLoadedTemplate={hasLoadedTemplate}
      />
    </div>
  );
}
